// React
import { useState, useEffect } from "react";
import { useFormik } from "formik";
//PrimeReact
import { InputMask } from "primereact/inputmask";
import { InputText } from "primereact/inputtext";
import { Button } from "primereact/button";
import { useLocation } from "react-router";

// global
import { printToast, summaryExclusaoSucessoPadrao, detailExclusaoSucessoPadrao, pageableApi } from "../../config/global";

//Seplag
import CardSeplag from "../../components/CardSeplag";
import TableSeplag from "../../components/TableSeplag";
import RotuloSeplag from "../../components/RotuloSeplag";
import CardExibirPDF from "../../components/CardExibirPDF";

// Component
import ModalDetalheObrigacao from "./ModalManterObrigacao";

//Service
import { FormDetalheDaObrigacao as initForm, consultaManterObrigacao, buscaGenerica, remover as removerObrigacao, pesquisaAll as listaObrigacaoAll, buscarPeloCodigo, relatorioObrigacao } from "../../service/manterObrigacao";


import ObrigacaoLoader from "./ObrigacaoLoader";
import { useSelector, useDispatch } from "react-redux";
import usePermissions from "../../hooks/usePermissions";
import download from "downloadjs";

const camposTabela = [
  { nome: "nomePessoa", titulo: "Beneficiário" },
  { nome: "numCpfFormatado", titulo: "CPF" },
  { nome: "numrMatricula", titulo: "Matrícula" },
  { nome: "amparoLegal.descAmparoLegal", titulo: "Amparo Legal" },
  { nome: "siglOrgao", titulo: "Orgão" },
  { nome: "numrCertidao", titulo: "Nº de Certidão de Crédito" },
];

const Index = () => {

  // const arrayPermission = usePermissions({ nomeTela: 'CREDITOSALARIAL' })

  const dispatch = useDispatch();
  const count = useSelector((state) => state.counterRequestReducer.counterRequest);
  const filterObrigacao = useSelector((state) => state.filterObrigacaoReducer);
  const location = useLocation();

  const isLoading = count > 0;

  const [form, setForm] = useState(initForm);
  const [isEdit, setIsEdit] = useState(false);
  const [obrigacaoApi, setObrigacaoApi] = useState(pageableApi)
  const [showForm, setShowForm] = useState(false);
  const [checkCertidoesNaoEmitidas, setCheckCertidoesNaoEmitidas] = useState(false);
  const [activeImprimirUnico, setActiveImprimirUnico] = useState(false);
  const [base64Imprimir, setBase64Imprimir] = useState('');

  const { pagina, row } = filterObrigacao


  const reduxDispatch = (parmFiltro, pagina, row = 0) => {

    parmFiltro.numrCpf = parmFiltro.numrCpf ? parmFiltro.numrCpf.replace(/[^\w\s]|_/g, "") : parmFiltro.numrCpf

    dispatch({
      type: "SETFILTER_OBRIGACAO",
      value: {
        filter: { ...parmFiltro },
        pagina: pagina,
        row: row,
      }
    });
  }

  const handleBuscaGenerica = (filtro = consultaManterObrigacao, page = 0, row = 10) => {
    let paginacao = `page=${page}&size=${row}`;

    buscaGenerica(filtro, paginacao).then((res) => {
      let dadosApi = res

      dadosApi.content = dadosApi.content.map(function (element) {

        let novoElement = {
          ...element,
          numCpfFormatado: element.numrCpf ? element.numrCpf.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, "$1.$2.$3-$4") : "",
          flagQuitada: element.flagQuitada ? element.flagQuitada : "",
          dataCancelamento: element.dataCancelamento ? element.dataCancelamento : "",
          codgValidadorObrigacao: element.codgValidadorObrigacao ? element.codgValidadorObrigacao : "",
          descSituacao: element.descSituacao ? element.descSituacao : "",
          flagSituacao: element.flagSituacao ? element.flagSituacao : "",
        };

        return novoElement;
      })

      setObrigacaoApi(dadosApi)
      reduxDispatch(formik.values, page, row, dadosApi)
    });
  }

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: consultaManterObrigacao,
    onSubmit: async () => {
      let FLAG_QUITADO_FOLHA_ARCH = formik.values.flagQuitadoFolhaArh !== true ? FLAG_QUITADO_FOLHA_ARCH === "N" : FLAG_QUITADO_FOLHA_ARCH === "S";
      let NUMERO_CERTIDAO = checkCertidoesNaoEmitidas ? "0000000000" : String(formik.values.numrCertidao) === "null" ? null : formik.values.numrCertidao.toString();

      let flagEmitida = null

      if (formik.values.checkCertidoesNaoEmitidas) {
        flagEmitida = 'N'
      }

      if (formik.values.flagEmitida) {
        flagEmitida = 'E'
      }

      let payload = {
        pessoa: formik.values.pessoa,
        cpf: formik.values.numrCpf ? formik.values.numrCpf.replace(/[^\w\s]|_/g, "") : formik.values.numrCpf,
        numrMatricula: formik.values.numrMatricula,
        numrCertidao: NUMERO_CERTIDAO,
        flagQuitada: !formik.values.flagQuitada ? (formik.values.flagQuitada = null) : 'Q',
        flagCompensada: !formik.values.flagCompensada ? (formik.values.flagCompensada = null) : 'C',
        flagAutenticacao: !formik.values.flagAutenticacao ? (formik.values.flagAutenticacao = null) : 'A',
        flagEmitida,
        flagQuitadoFolhaArh: FLAG_QUITADO_FOLHA_ARCH,
      };


      handleBuscaGenerica(payload, 0, row)

    },
  });


  useEffect(() => {


    if (location.state) {

      const { cpf: parmCpf, nomePessoa, numrCert } = location.state;
      formik.setFieldValue("numrCpf", parmCpf);
      formik.setFieldValue("pessoa", nomePessoa);
      if (numrCert > 0) {
        formik.setFieldValue("numrCertidao", numrCert);
      }

      let filtro = {
        cpf: parmCpf ? parmCpf : '',
        numrCertidao: numrCert > 0 ? numrCert : '',
        pessoa: nomePessoa ? nomePessoa : '',
      };

      handleBuscaGenerica(filtro, 0, row)

    } else {

      formik.setValues(filterObrigacao.filter)

      let filtro = {
        cpf: filterObrigacao.filter.numrCpf,
        numrCertidao: filterObrigacao.filter.numrCertidao,
        pessoa: filterObrigacao.filter.pessoa,
      };

      handleBuscaGenerica(filtro, pagina, row)

    }

  }, []);

  const handleFechar = () => {
    setShowForm(false);
  };

  const onEditarDado = async (rowData) => {
    let response = await buscarPeloCodigo(rowData.idenObrigacao);

    setForm({ ...response, listaAmparoLegalObrigacao: [...response.listaAmparoLegalObrigacao, { ...response.amparoLegal }] });
    setShowForm(true);
    setIsEdit(true);
  };

  const paginacao = async (event) => {

    let FLAG_QUITADO_FOLHA_ARCH = formik.values.flagQuitadoFolhaArh !== true ? FLAG_QUITADO_FOLHA_ARCH === "N" : FLAG_QUITADO_FOLHA_ARCH === "S";
    let NUMERO_CERTIDAO = checkCertidoesNaoEmitidas ? "0000000000" : String(formik.values.numrCertidao) === "null" ? null : formik.values.numrCertidao.toString();

    let flagEmitida = null

    if (formik.values.checkCertidoesNaoEmitidas) {
      flagEmitida = 'N'
    }

    if (formik.values.flagEmitida) {
      flagEmitida = 'E'
    }

    let payload = {
      pessoa: formik.values.pessoa,
      cpf: formik.values.numrCpf ? formik.values.numrCpf.replace(/[^\w\s]|_/g, "") : formik.values.numrCpf,
      numrMatricula: formik.values.numrMatricula,
      numrCertidao: NUMERO_CERTIDAO,
      flagQuitada: !formik.values.flagQuitada ? (formik.values.flagQuitada = null) : 'Q',
      flagCompensada: !formik.values.flagCompensada ? (formik.values.flagCompensada = null) : 'C',
      flagAutenticacao: !formik.values.flagAutenticacao ? (formik.values.flagAutenticacao = null) : 'A',
      flagEmitida,
      flagQuitadoFolhaArh: FLAG_QUITADO_FOLHA_ARCH,
    };

    handleBuscaGenerica(payload, event.page, event.rows)

  };

  const HandleBotaoVisualizar = (rowData) => {
    return (
      <>
        {/* {rowData.idenObrigacao == 150 &&

          <Link
            to={{
              pathname: `/certidoesAtivas`,
              state: {
                nomePessoa: rowData.nomePessoa,
                numrCpfTitular: rowData.numrCpf
              }
            }}
            style={{ marginLeft: '5px' }}
          >
            <Button icon="pi pi-cog" />
          </Link>
        } */}
      </>
    );
  };

  const onExportarCreditoSalarial = async () => {

    let NUMERO_CERTIDAO = checkCertidoesNaoEmitidas ? "0000000000" : String(formik.values.numrCertidao) === "null" ? null : formik.values.numrCertidao.toString();

    let payload = {
      nomePessoa: formik.values.pessoa,
      numrCpfTitular: formik.values.numrCpf ? formik.values.numrCpf.replace(/[^\w\s]|_/g, "") : formik.values.numrCpf,
      numrMatricula: formik.values.numrMatricula,
      numrCertidao: NUMERO_CERTIDAO,
      tipoRelatorio: "E"
    }

    payload.numrCertidao = payload.numrCertidao == "" ? null : payload.numrCertidao


    const response = await relatorioObrigacao(payload);

    download(`data:application/excel;base64,${response.dadosRelatorioBase64}`, response.nomeArquivo, "application/excel");

  }

  async function showModalFiltrarCreditoSalarial() {

    let NUMERO_CERTIDAO = checkCertidoesNaoEmitidas ? "0000000000" : String(formik.values.numrCertidao) === "null" ? null : formik.values.numrCertidao.toString();

    let payload = {
      nomePessoa: formik.values.pessoa,
      numrCpfTitular: formik.values.numrCpf ? formik.values.numrCpf.replace(/[^\w\s]|_/g, "") : formik.values.numrCpf,
      numrMatricula: formik.values.numrMatricula,
      numrCertidao: NUMERO_CERTIDAO,
      tipoRelatorio: "P"
    }

    payload.numrCertidao = payload.numrCertidao == "" ? null : payload.numrCertidao

    const { dadosRelatorioBase64 } = await relatorioObrigacao(payload);

    setBase64Imprimir('data:application/pdf;base64,' + dadosRelatorioBase64)

    setActiveImprimirUnico(true);
  }

  return (
    <CardSeplag title="Crédito Salarial">
      {isLoading && <ObrigacaoLoader />}

      {!isLoading && (
        <form className="p-col-12" onSubmit={formik.handleSubmit}>
          <div className="p-grid p-col-12">

            <div className="p-col-12" />

            <RotuloSeplag nome="Beneficiário" cols="12 6 3">
              <InputText name="pessoa" id="pessoa" onChange={formik.handleChange} value={formik.values.pessoa} style={{ width: "100%" }} />
            </RotuloSeplag>

            <RotuloSeplag nome="CPF" cols="12 6 3">
              <InputMask name="numrCpf" id="numrCpf" mask="999.999.999-99" style={{ width: "100%" }} onChange={formik.handleChange} value={formik.values.numrCpf} />
            </RotuloSeplag>

            <RotuloSeplag nome="Matrícula" cols="12 6 3">
              <InputText name="numrMatricula" id="numrMatricula" onChange={formik.handleChange} value={formik.values.numrMatricula} style={{ width: "100%" }} />
            </RotuloSeplag>

            <RotuloSeplag nome="Nº Certidão de Crédito" cols="12 6 3">
              <InputText name="numrCertidao" id="numrCertidao" disabled={formik.values.checkCertidoesNaoEmitidas ? true : false} onChange={formik.handleChange} value={formik.values.numrCertidao} style={{ width: "100%" }} />
            </RotuloSeplag>

            <div className="p-col-12 p-md-2" style={{ marginTop: "10px" }}>
              <Button icon="pi pi-search" label="Filtrar" className="p-col" />
            </div>
          </div>
        </form>
      )}

      <TableSeplag
        dados={obrigacaoApi.content}
        totalRecords={obrigacaoApi.totalElements}
        camposTabela={camposTabela}
        hasEventoAcao
        onEditarDado={(rowData, index) => onEditarDado(rowData)}
        botoesAcoes={HandleBotaoVisualizar}
        onPage={paginacao}
        page={pagina}
        rows={row}
        onImprimir={showModalFiltrarCreditoSalarial}
        onExportar={onExportarCreditoSalarial}
        onModalSearch

      />
      {showForm && (
        <ModalDetalheObrigacao
          onFechar={handleFechar}
          showForm={showForm}
          form={form}
          edit={isEdit}
          atualizaTabela={handleBuscaGenerica}
        />
      )}

      {
        activeImprimirUnico &&
        <CardExibirPDF
          onHide={() => setActiveImprimirUnico(false)}
          alturaTela="900"
          // tamanhoTela="980"
          isExibirPDF={activeImprimirUnico}
          stringPDF={base64Imprimir}
        />
      }
    </CardSeplag>
  );
};

export default Index;
